module.exports = __webpack_public_path__ + "media/stasis.10c51237.mp3";